// This is temporary until the whole contact record is in React, in which case it will have its own boundary
import React from 'react';
import PropTypes from 'prop-types';

import { error } from 'utils/rollbarLogger';

class PartialErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(e, errorInfo) {
    error('PartialErrorBoundaryError', e, errorInfo);
  }

  render() {
    const { children, errorContent } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return errorContent();
    }

    return children;
  }
}

PartialErrorBoundary.defaultProps = {
  children: null,
  errorContent: () => <div className={'alert alert-danger'}>RENDER ERROR</div>
};

PartialErrorBoundary.propTypes = {
  children: PropTypes.node,
  errorContent: PropTypes.func
};

export default PartialErrorBoundary;
